import DoneIcon from '@mui/icons-material/Done';
import ErrorIcon from '@mui/icons-material/ErrorOutline';
import React from 'react';
import { useTranslation } from 'react-i18next';

const CustomInput = ({
   title,
   required,
   inputType,
   handleInputChange = () => { },
   name,
   id,
   isError,
   isSuccess,
   message,
   minValue,
   maxValue,
   readOnly,
   value,
   placeholder,
   autoFocus,
   className = '',
   containerClassName = '',
   labelEnable = true,
   tooltip,
}) => {
   const { t } = useTranslation();

   const displayValue =
      readOnly && typeof value === 'string' &&
         value.trim().toLowerCase() === 'all users'
         ? t('common.all-user')
         : value;
   return (
      <div className={`${containerClassName}`}>
         {labelEnable && (
            <label className="block text-sm">
               {title}
               {required && <span className="text-[#EF4444] ml-1">*</span>}
            </label>
         )}

         <div className={`${labelEnable ? 'mt-2' : ''} relative`}>
            <input
               autoFocus={autoFocus}
               type={inputType}
               name={name}
               id={id}
               className={`${isError ? 'invalid' : ''} ${isSuccess ? 'success' : ''
                  } form-control h-[40px] rounded-[10px] truncate focus:!border-[#E5E7EB] focus:!outline-none focus:!shadow-none focus-visible:!outline-none active:!outline-none ${className}`}
               {...(inputType === 'number' ? { min: minValue, max: maxValue } : {})}
               readOnly={readOnly}
               value={displayValue}
               placeholder={placeholder}
               onChange={handleInputChange}
               title={tooltip}
            />

            {isError && <p className="text-[14px] text-red-500 mt-1">{message}</p>}

            {isSuccess && (
               <span className="absolute inset-y-[-2px] right-0 px-3 py-3">
                  <DoneIcon fontSize="small" className="text-green-500" />
               </span>
            )}

            {isError && (
               <span className="absolute inset-y-[-2px] right-0 px-3 py-3">
                  <ErrorIcon fontSize="small" className="text-red-500" />
               </span>
            )}
         </div>
      </div>
   );
};


export default CustomInput;
